import React from 'react'
import {NavLink} from 'react-router-dom'

interface MobileMenuLinkProps {
  children: React.ReactNode
  to: string
}

function MobileMenuLink({children, to}: MobileMenuLinkProps) {
  return (
    <NavLink
      activeClassName="bg-surface-subtle text-color-strong"
      to={to}
      className="px-sm py-xs text-color-subtle hover:bg-surface-strong group flex w-24 justify-center text-sm font-medium"
    >
      {children}
    </NavLink>
  )
}

export {MobileMenuLink}
